import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/context/AuthContext'
import { ToastProvider } from '@/context/ToastContext'
import { ThemeProvider } from '@/context/ThemeContext'
import { NotificationProvider } from '@/context/NotificationContext'
import ErrorBoundary from '@/components/ui/ErrorBoundary'
import PageLoader from '@/components/ui/PageLoader'
import DashboardShell from '@/components/layout/DashboardShell'

import {
  LoginPage,
  OtpPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  DashboardPage,
  ArchivePage,
  SettingsPage,
  SupportPage,
} from '@/pages'
import { VerifyEmailPage } from '@/pages/auth/VerifyEmailPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return <PageLoader />
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

function DashboardLayout() {
  const location = useLocation()
  return (
    <DashboardShell>
      <div key={location.pathname} className="screen-fade dashboard-page-transition">
        <Outlet />
      </div>
    </DashboardShell>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <NotificationProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/otp" element={<OtpPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="archive" element={<ArchivePage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="support" element={<SupportPage />} />
              </Route>
              <Route path="/settings/verify-email" element={<VerifyEmailPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </NotificationProvider>
        </ToastProvider>
      </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
